import View from "@/Views/View";
import WebComponentBinding from "@/Infrastructure/CustomBindings/WebComponentBinding";
import { WebComponentBindingOptions } from "#/CoreFrameInterfaces";
import ComponentManager from "@/Management/ComponentManager";

export interface IWebComponentViewConstructorParameters<TOriginalComponent = unknown> {
    tagName: string;
    bindingOptions: WebComponentBindingOptions<TOriginalComponent>;
}

export default class WebComponentView<TOriginalComponent = unknown> extends View {
    protected tagName: IWebComponentViewConstructorParameters<TOriginalComponent>['tagName'];
    protected bindingOptions: IWebComponentViewConstructorParameters<TOriginalComponent>['bindingOptions'];

    constructor(params: IWebComponentViewConstructorParameters<TOriginalComponent>) {
        super();

        this.tagName = params.tagName;
        this.bindingOptions = params.bindingOptions;
    }

    public getView(): JQuery {
        return WebComponentBinding.createElement(this.tagName, this.bindingOptions);
    }
}

ComponentManager.setView('WebComponentView', WebComponentView, 'RADPresentation.HTMLClient.DefaultViewExtensions')
